import { useEffect } from 'react';
import { useTemplateContext, useFormContext, Template } from 'src/lib/templates';
import { AnyObject } from 'src/commons';
import { MultiStepFormSteps } from '../../../../lib/MultiStepForm/types';

export const useStepTemplateLogic = (currentStep: MultiStepFormSteps) => {
  const { form } = useFormContext<AnyObject>();
  const { setTemplate } = useTemplateContext();

  useEffect(() => {
    if (!currentStep?.template?.name) return;

    const newTemplate: Template = {
      name: currentStep.template.name,
      template: [currentStep.template],
    };

    setTemplate(newTemplate);

    const stepValues = form.getState().values?.[currentStep.template.name];
    if (!stepValues || Object.keys(stepValues).length === 0) {
      form.change(currentStep.template.name, currentStep.initialValue);
    }
  }, [currentStep, form, setTemplate]);
};
